import React from "react";
import Navbar from "../../../components/Navbar";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import style from "./PesagemInicial.module.css";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../../../components/Input";
import SubmitButton from "../../../components/Button";
import Select from "../../../components/select";
import { useState, useEffect } from "react";
import Axios from "axios";
import { SnackbarProvider, useSnackbar } from "notistack";
import MaskedInput from "../../../components/InputMask";
import moment from "moment";

const PesagemInicial = () => {
  const navigate = useNavigate();

  useEffect(() => {
    getTipoveiculo();
    getOperacoes();
    getTransp();
    fetchPlacas(cpf); // Fetch PLACA_CAVALO based on the CPF
  }, []);

  const fetchPlacas = async (cpf) => {
    try {
      const response = await Axios.get(
        `https://operacao.setlogistica.com.br/api/pesageminicial/historico/${cpf}`
      );
      if (response.data.length > 0) {
        const {
          PLACA_CAVALO,
          PLACA_CARRETA,
          PLACA_CARRETA2,
          PLACA_CARRETA3,
          TIPO_VEICULO,
        } = response.data[0]; // Destructure the response
        setPlacacavalo(PLACA_CAVALO);
        setPlaca1(PLACA_CARRETA || ""); // Set or default to empty string
        setPlaca2(PLACA_CARRETA2 || "");
        setPlaca3(PLACA_CARRETA3 || "");
        setTipoveiculo(TIPO_VEICULO || "");
      }
    } catch (error) {
      console.error("Error fetching vehicle plate data:", error);
    }
  };

  const [operacoesList, setOperacoesList] = useState([]);
  const [pedidosByDoc, setPedidosByDoc] = useState([]);
  const [docs, setDocs] = useState([]);
  const [pedidoMic, setPedidoMic] = useState([]);
  const [teste, setTeste] = useState(false);
  const [destinos, setDestinos] = useState([]);
  const [destino, setDestino] = useState("");
  const [mensagemNavioSelecionado, setMensagemNavioSelecionado] = useState("");
  const [pedidos, setPedidos] = useState([]);
  const [saldodoc, setSaldodoc] = useState([]);
  const [doc, setDoc] = useState("");
  const [navio, setNavio] = useState("");
  const [disabled, setDisabled] = useState(true); // Define o campo como desabilitado inicialmente
  const [tara, setTara] = useState(1000); // Define o peso inicial de 1000 KG

  const [minuta, setMinuta] = useState("");
  const [placacavalo, setPlacacavalo] = useState("");
  const [placaCarreta, setPlacaCarreta] = useState("");
  const [placaCarreta2, setPlacaCarreta2] = useState("");
  const [placaCarreta3, setPlacaCarreta3] = useState("");
  const [placa1, setPlaca1] = useState("");
  const [placa2, setPlaca2] = useState(null);
  const [placa3, setPlaca3] = useState(null);
  const [data, setData] = useState("");
  const [transportadora, setTransportadora] = useState([]);
  const [transportadoras, setTransportadoras] = useState([]);
  const [tipopesagem, setTipopesagem] = useState("M"); // Define 'M' como valor inicial para MOEGA
  const [tipoveiculo, setTipoveiculo] = useState("");
  const [tipoveiculos, setTipoveiculos] = useState([]);

  const [saldoTons, setSaldoTons] = useState(null);
  const [porcentagem, setPorcentagem] = useState(null);
  const [qtdeManifestada, setQtdeManifestada] = useState(null);
  const [pesoLiquido, setPesoLiquido] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [authCode, setAuthCode] = useState("");
  const [motivacao, setMotivacao] = useState("S");
  const [gate, setGate] = useState("");
  const [capacidade, setCapacidade] = useState("");
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [saldoCadastro, setSaldoCadastro] = useState(null);

  const usuario = JSON.parse(localStorage.getItem("user_token")).id;

  const validaPlaca = (placa) => {
    // Expressão regular para validar placas no formato antigo (AAA1234) ou Mercosul (AAA1B23)
    const placaRegex =
      /^[A-Z]{3}\d{4}$|^[A-Z]{3}\d{1}[A-Z]{1}\d{2}$|^[A-Z]{3}\d{2}[A-Z]{1}\d{1}$/;

    return placaRegex.test(placa);
  };

  const validaDados = async () => {
    const date = new Date();
    date.setHours(date.getHours() - 3);
    const currentDate = date.toISOString().slice(0, 19).replace("T", " ");

    if (!doc || !tipoveiculo || !transportadora || !tipopesagem) {
      showAlert("Preencha todos os campos.", "error");
      return;
    }

    if (!validaPlaca(placacavalo)) {
      showAlert(
        "Placa do cavalo deve estar no formato correto (Ex: AAA1234 ou AAA1B23)",
        "error"
      );
      return;
    }

    if (
      (placa1 && !validaPlaca(placa1)) ||
      (placa2 && !validaPlaca(placa2)) ||
      (placa3 && !validaPlaca(placa3))
    ) {
      showAlert(
        "Uma das placas da carreta está no formato incorreto.",
        "error"
      );
      return;
    }

    if (!tara) {
      showAlert(
        '"Peso (Tara)" é obrigatório. Coloque em 2.000 KG caso não tenha o conhecimento da TARA.',
        "error"
      );
      return;
    }

    if (!minuta) {
      showAlert('"Número da Minuta" é obrigatório.', "error");
      return;
    }

    try {
      const response = await Axios.get(
        `https://operacao.setlogistica.com.br/api/valida/placa/${placacavalo}`
      );
      const carregamento = response.data;

      if (carregamento.ID_CARREGAMENTO) {
        showAlert(
          `Há um carregamento em aberto com Placa Cavalo no Navio: ${carregamento.NOME_NAVIO} com ID: ${carregamento.ID_CARREGAMENTO}`,
          "error"
        );
      } else {
        const pedidoResponse = await Axios.post(
          "https://operacao.setlogistica.com.br/api/valida/pedidomic/saldo",
          {
            COD_OPERACAO: navio,
            NR_PEDIDO: pedidoMic,
          }
        );

        if (pedidoResponse.data.error) {
          showAlert("Erro ao validar pedido MIC.", "error");
        } else if (pedidoResponse.data.length === 0) {
          showAlert("Nenhum saldo encontrado para o pedido MIC.", "info");
        } else {
          const saldoTons = pedidoResponse.data[0].SALDO_PEDIDO_MIC / 1000;

          const usuario = JSON.parse(localStorage.getItem("user_token")).id;

          const usuariosComLimiteBaixo = [
            "marcos",
            "alexandre.soares",
            "lucas.rodrigues",
            "henrique.nievas",
          ];

          const limite = usuariosComLimiteBaixo.includes(usuario) ? 1 : 80;

          if (saldoTons < limite) {
            showAlert(
              `O saldo de pedido MIC está abaixo de ${limite} toneladas, não é possível carregar.`,
              "error"
            );
          } else {
            addPesagem(currentDate);
          }
        }
      }
    } catch (error) {
      console.error("Erro ao validar:", error);
      showAlert("Erro ao registrar o carregamento", "error");
    }
  };

  const [dadosUsuarioNav, setDadosUsuarioNav] = useState(null);

  useEffect(() => {
    if (usuario) {
      Axios.get(`https://operacao.setlogistica.com.br/api/user-nav/${usuario}`)
        .then((res) => {
          setDadosUsuarioNav(res.data);
          console.log("Usuário NAV:", res.data);
        })
        .catch((err) => {
          console.error("Erro ao buscar dados do usuário NAV:", err);
        });
    }
  }, [usuario]);

  const handleAuthSubmit = async () => {
    setIsAuthenticating(true);
    try {
      const response = await Axios.post(
        "https://operacao.setlogistica.com.br/api/validate-token",
        {
          token: authCode,
        }
      );
      setIsAuthenticating(false); // Habilita o botão após respost
      if (response.data.valid) {
        handleCloseModal();
        addPesagem(getDate());
        showAlert("Autenticação bem-sucedida", "success");
      } else {
        showAlert("Código incorreto", "error");
      }
    } catch (error) {
      console.error("Erro ao validar o código de autenticação:", error);
      showAlert("Erro na autenticação de dois fatores.", "error");
      setIsAuthenticating(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setAuthCode("");
  };

  const validaTecla = (e) => {
    if (e.key === "Enter") {
      validaDados();
    }
  };

  const validaTipo = (val) => {
    if (val === "C") {
      showAlert("Pesagem completa selecionada com sucesso!", "success");
      setDisabled(false);
      setTara(0);
    } else {
      showAlert("Pesagem moega selecionada com sucesso!", "success");
      setTara(1000);
      setDisabled(true);
    }
  };

  const addPesagem = (dataTara) => {
    Axios.post(
      "https://operacao.setlogistica.com.br/api/pesagem/primeirapesagem",
      {
        COD_CARGA: doc,
        COD_OPERACAO: navio,
        PLACA_CAVALO: placacavalo,
        COD_MOTORISTA: id,
        PLACA_CARRETA: placa1,
        PLACA_CARRETA2: placa2,
        PLACA_CARRETA3: placa3,
        TIPO_VEICULO: tipoveiculo,
        COD_TRANSP: transportadora,
        PESO_TARA: tara,
        DATA_TARA: dataTara, // Usa a data passada como argumento
        USUARIO_TARA: usuario,
        STATUS_CARREG: "1",
        USUARIO: usuario,
        DATA_CADASTRO: getDate(),
        NR_PEDIDO: pedidoMic,
        MINUTA: minuta,
        TIPO_PESAGEM: tipopesagem,
        MOTIVACAO: motivacao,
        GATE: gate,
      }
    )
      .then(function (res) {
        if (res.data.success) {
          const idCarregamento = res.data.ID_CARREGAMENTO;

          // Incluindo o ID_CARREGAMENTO na mensagem de sucesso
          showAlert(
            `Pesagem cadastrada com sucesso! ID: ${idCarregamento}`,
            "success"
          );
          setTimeout(() => {
            navigate("/veiculos/BuscarMotorista");
          }, 2500);

          if (motivacao === "S") {
            Axios.post(
              "https://operacao.setlogistica.com.br/api/executarPuppeteer",
              {
                ID_CARREGAMENTO: idCarregamento,
                COD_OPERACAO: navio,
                COD_MOTORISTA: id,
                CPF_MOTORISTA: cpf, // Adicionando o CPF aqui
              }
            )
              .then((puppeteerResponse) => {
                // Tratamento da resposta do Puppeteer
              })
              .catch((error) => {
                console.error("Erro ao executar Puppeteer:", error);
                showAlert("Erro ao executar Puppeteer.", "error");
              });
          }
        } else if (res.data.sqlMessage) {
          showAlert(res.data.sqlMessage, "error");
        }
      })
      .catch(function (error) {
        console.error("Erro ao cadastrar a pesagem:", error);
        showAlert(
          `Ocorreu um erro ao cadastrar a pesagem: ${error.message}`,
          "error"
        );
      });
  };

  const getDate = () => {
    const date = new Date();
    date.setHours(date.getHours() - 3);
    return date.toISOString().slice(0, 19).replace("T", " ");
  };

  const getOperacoes = () => {
    Axios.get("https://operacao.setlogistica.com.br/api/operacao").then(
      (response) => {
        setOperacoesList(response.data);
        console.log(response.data);
        getCargas();
      }
    );
  };

  const getCargas = (id) => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/carga/busca/${id}`
    ).then(function (res) {
      setDocs(res.data);
      console.log(res.data);
      getPedido(id);
    });
  };

  const getTransp = () => {
    Axios.get(`https://operacao.setlogistica.com.br/api/transportadora`).then(
      function (res) {
        console.log(res.data);
      }
    );
  };

  const getDestino = (idPedido) => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/pesageminicial/pedido/${idPedido}`
    )
      .then((res) => {
        // A resposta direta contém o nome do destino
        const destinoInfo = res.data;
        setDestino(destinoInfo.NOME_DESTINO); // Atualiza o estado do destino com o nome obtido
      })
      .catch((error) => {
        console.error("Erro ao buscar informações do destino:", error);
        showAlert("Erro ao carregar informações do destino.", "error");
      });
  };

  const getTipoveiculo = () => {
    Axios.get(`https://operacao.setlogistica.com.br/api/tipoveiculo`).then(
      function (res) {
        console.log(res.data); // Confirme se CAPACIDADE está sendo retornada
        setTipoveiculos(res.data);
      }
    );
  };

  const getPedido = (id) => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/pesageminicial/pedidos/${id}`
    ).then(function (res) {
      setPedidosByDoc(res.data);
      console.log(res.data);
    });
  };

  const getSaldoPedido = (nrPedido) => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/saldoPedido/${nrPedido}`
    )
      .then((res) => {
        if (
          res.data.query1Result &&
          res.data.query2Result &&
          res.data.query2Result.length > 0
        ) {
          const query1Result = res.data.query1Result; // Resultado do primeiro SELECT
          const query2Result = res.data.query2Result[0]; // Primeiro item do segundo SELECT

          // Soma a capacidade de todos os registros retornados pelo primeiro SELECT
          const capacidadeTotal = query1Result.reduce(
            (total, item) => total + (item.CAPACIDADE || 0),
            0
          );

          const qtdeManifestada = query2Result.QTDE_MANIFESTADA_PEDIDO;
          const pesoLiquido = query2Result.PESO_LIQUIDO_POR_PEDIDO_MIC;

          // Calcula o saldoCadastro com a nova fórmula
          const saldoCadastro = qtdeManifestada - pesoLiquido - capacidadeTotal;

          // Calcula a porcentagem como Peso Líquido sobre o Manifestado
          const saldoPorcentagem = qtdeManifestada
            ? (pesoLiquido / qtdeManifestada) * 100
            : 0;

          // Conversão de saldo restante para toneladas
          const saldoTons = saldoCadastro / 1000;

          // Atualiza os estados
          setQtdeManifestada(qtdeManifestada);
          setPesoLiquido(pesoLiquido);
          setPorcentagem(saldoPorcentagem);
          setSaldoTons(saldoTons);
          setSaldoCadastro(saldoCadastro); // Atualiza saldoCadastro diretamente
        } else {
          // Caso não haja resultados, chamar a rota alternativa
          Axios.get(
            `https://operacao.setlogistica.com.br/api/qtdemanifestada/${nrPedido}`
          )
            .then((res) => {
              if (res.data.QTDE_MANIFESTADA_PEDIDO) {
                const qtdeManifestada = res.data.QTDE_MANIFESTADA_PEDIDO;
                const capacidadeTotal = 0; // Sem resultados, capacidadeTotal será 0
                const pesoLiquido = 0; // Sem resultados, pesoLiquido será 0

                // Calcula o saldoCadastro com os valores ajustados
                const saldoCadastro =
                  qtdeManifestada - pesoLiquido - capacidadeTotal;

                // Calcula a porcentagem como Peso Líquido sobre o Manifestado
                const saldoPorcentagem = qtdeManifestada
                  ? (pesoLiquido / qtdeManifestada) * 100
                  : 0;

                // Conversão de saldo restante para toneladas
                const saldoTons = saldoCadastro / 1000;

                // Atualiza os estados
                setQtdeManifestada(qtdeManifestada);
                setPesoLiquido(pesoLiquido);
                setPorcentagem(saldoPorcentagem);
                setSaldoTons(saldoTons);
                setSaldoCadastro(saldoCadastro);
              } else {
              }
            })
            .catch((error) => {
              console.error("Erro ao buscar quantidade manifestada:", error);
              showAlert("Erro ao carregar quantidade manifestada.", "error");
            });
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar saldo do pedido:", error);
        showAlert("Erro ao carregar saldo do pedido.", "error");
      });
  };

  const { enqueueSnackbar } = useSnackbar();
  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant: variant });
  };

  const handlePedidoChange = (e) => {
    const selectedPedido = e.target.value;
    setPedidoMic(selectedPedido); // Armazena o valor `nrPedido` selecionado
    getDestino(selectedPedido); // Atualiza o destino com base no `nrPedido`
    getSaldoPedido(selectedPedido); // Chama a função para buscar o saldo do pedido
    getTransportadoresByPedido(selectedPedido); // Busca os transportadores relacionados ao pedido
  };

  const getTransportadoresByPedido = (pedidoId) => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/pesageminicial/transportadorap/pedido/${pedidoId}`
    )
      .then((response) => {
        setTransportadoras(response.data); // Armazena a lista de transportadoras no estado
      })
      .catch((error) => {
        console.error("Erro ao buscar transportadoras do pedido:", error);
        showAlert("Erro ao carregar transportadoras do pedido.", "error");
      });
  };

  let { nome } = useParams();
  let { cpf } = useParams();
  let { cnh } = useParams();
  let { id } = useParams();

  return (
    <>
      <Navbar veiculos />
      <Header />
      <Brackground />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div className={style.nav}>
              <div onClick={() => navigate("/veiculos/BuscarMotorista")}>
                Motorista
              </div>
              <div onClick={() => navigate("/veiculos")}>
                Cadastrar Motorista
              </div>
              <div className={style.active}>1° Pesagem</div>
            </div>
          </div>

          <div className={style.align}>
            <div className="columns">
              {/* Dados do Motorista */}
              <div className="column is-4">
                <fieldset className={style.fieldset_alt}>
                  <legend className={style.legend}>Dados do Motorista</legend>
                  <div className={style.card}>
                    <div className={style.cabecario}>
                      <p>
                        {" "}
                        <strong>Motorista:</strong> {nome}
                      </p>
                      <p>
                        <strong>CPF:</strong> {cpf}
                      </p>
                      <p>
                        <strong>CNH:</strong>{" "}
                        {cnh == "null" ? "Não Registrado" : cnh}
                      </p>
                    </div>
                  </div>
                </fieldset>

                {/* Tipo de Pesagem */}
                <fieldset className={style.fieldset}>
                  <legend className={style.legend}>Tipo de Pesagem</legend>

                  <div className={style.control}>
                    <label className={style.input}>
                      <input
                        type="radio"
                        onChange={(e) => [
                          setTipopesagem(e.target.value),
                          validaTipo(e.target.value),
                        ]}
                        value="M"
                        name="tipoPesagem"
                        checked={tipopesagem === "M"} // Define checked como true se tipopesagem for igual a 'M'
                      />
                      MOEGA
                    </label>
                    <label className={style.input}>
                      <input
                        type="radio"
                        onChange={(e) => [
                          setTipopesagem(e.target.value),
                          validaTipo(e.target.value),
                        ]}
                        value="C"
                        name="tipoPesagem"
                        checked={tipopesagem === "C"} // Defina checked como true se tipopesagem for igual a 'C'
                      />
                      CHAVE DE OURO
                    </label>
                  </div>
                </fieldset>
                <fieldset className={style.fieldset_alt}>
                  <legend className={style.legend}>Escolha o Navio</legend>

                  <select
                    onChange={(e) => {
                      // Resetar os campos
                      setDoc("");
                      setPedidoMic(""); // Reseta o Pedido MIC
                      setDestino(""); // Reseta o Destino
                      setTransportadora("");

                      // Chama as funções para carregar os dados relacionados ao navio
                      getCargas(e.target.value); // Carrega as cargas relacionadas ao navio selecionado
                      setNavio(e.target.value); // Atualiza o estado do navio
                    }}
                  >
                    <option disabled selected>
                      Escolha uma opção
                    </option>
                    {operacoesList
                      ?.filter((val) =>
                        ["OPERANDO", "PARALISADO", "FECHADA"].includes(
                          val.STATUS_OPERACAO
                        )
                      )
                      .map((val) => (
                        <option key={val.COD_OPERACAO} value={val.COD_OPERACAO}>
                          {val.NOME_NAVIO}
                        </option>
                      ))}
                  </select>
                </fieldset>

                {disabled == true ? (
                  <fieldset className={style.fieldset}>
                    <legend className={style.legend}>Peso Moega</legend>
                    <input
                      className={style.form_input}
                      type={"text"}
                      text={"Peso Vazio (Tara)"}
                      placeholder={" 1.000 KG"}
                      disabled={true}
                    />
                  </fieldset>
                ) : (
                  <fieldset className={style.fieldset}>
                    <legend className={style.legend}>Peso Vazio (Tara)</legend>
                    <input
                      className={style.form_input}
                      type={"text"}
                      placeholder={"Insira o Peso em KG"}
                      onChange={(e) => setTara(e.target.value)}
                    />
                  </fieldset>
                )}
              </div>
              <div className="column is-4">
                <fieldset className={style.fieldset_alt}>
                  <legend className={style.legend}>Dados do Veículo</legend>

                  <div className={style.bigbags}>
                    <div className={style.peso_bigbag}>
                      <label>Modelo do AUTO</label>
                      <select
                        onChange={(e) => {
                          const selectedVehicle = tipoveiculos.find(
                            (val) => val.COD_TIPO.toString() === e.target.value
                          ); // Encontre o veículo selecionado
                          setTipoveiculo(e.target.value); // Atualize o valor de tipoveiculo
                          setCapacidade(
                            selectedVehicle ? selectedVehicle.CAPACIDADE : ""
                          ); // Defina a capacidade se o veículo for encontrado
                        }}
                        value={tipoveiculo}
                      >
                        <option disabled value="">
                          Escolha uma opção
                        </option>
                        {tipoveiculos?.map((val) => (
                          <option key={val.COD_TIPO} value={val.COD_TIPO}>
                            {val.DESC_TIPO_VEICULO}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className={style.quantidade}>
                      <label>Lotação</label>
                      <p>
                        {capacidade
                          ? `${capacidade.toLocaleString("pt-BR", {
                              maximumFractionDigits: 0,
                            })} KG`
                          : ""}
                      </p>
                    </div>
                  </div>

                  <div className={style.placas}>
                    <div className={style.placaContainer}>
                      <label htmlFor="placaCavalo">Cavalo</label>
                      <input
                        type="text"
                        id="placaCavalo"
                        placeholder="Ex: AAA1234"
                        value={placacavalo}
                        onChange={(e) =>
                          setPlacacavalo(e.target.value.toUpperCase())
                        }
                      />
                    </div>

                    <div className={style.placaContainer}>
                      <label htmlFor="placa1">Carreta 1</label>
                      <input
                        type="text"
                        id="placa1"
                        placeholder="Ex: AAA1234"
                        value={placa1}
                        onChange={(e) =>
                          setPlaca1(e.target.value.toUpperCase())
                        }
                      />
                    </div>

                    <div className={style.placaContainer}>
                      <label htmlFor="placa2">Carreta 2</label>
                      <input
                        type="text"
                        id="placa2"
                        placeholder="Ex: AAA1234"
                        value={placa2}
                        onChange={(e) =>
                          setPlaca2(e.target.value.toUpperCase())
                        }
                      />
                    </div>

                    <div className={style.placaContainer}>
                      <label htmlFor="placa3">Carreta 3</label>
                      <input
                        type="text"
                        id="placa3"
                        placeholder="Ex: AAA1234"
                        value={placa3}
                        onChange={(e) =>
                          setPlaca3(e.target.value.toUpperCase())
                        }
                      />
                    </div>
                  </div>
                </fieldset>
                <fieldset className={style.fieldset_alt}>
                  <legend className={style.legend}></legend>
                  <div className={style.minuta}>
                    <div className={style.peso_bigbag}>
                      <label>Minuta</label>
                      <input
                        className={style.form_input}
                        type={"text"}
                        placeholder={"Insira a MINUTA"}
                        onChange={(e) => setMinuta(e.target.value)}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="column is-4">
                <fieldset className={style.fieldset_alt}>
                  <legend className={style.legend}>
                    Informações da Operação
                  </legend>
                  <div className={style.form_controllab}>
                    <div className={style.form_controldoc}>
                      <label>(DI ou BL)</label>
                      <select
                        onChange={(e) => {
                          const selectedDoc = e.target.value;
                          setDoc(selectedDoc);
                          setPedidoMic(""); // Reseta a seleção de PEDIDO MIC
                          setDestino(""); // Reseta o DESTINO
                          setTransportadora(""); // Reseta a Transportadora
                          getPedido(selectedDoc); // Atualiza os pedidos relacionados ao novo DI ou BL
                        }}
                        value={doc} // Define o valor atual selecionado
                      >
                        <option disabled value="">
                          Escolha uma opção
                        </option>
                        {docs?.map((val) => {
                          return (
                            <option value={val.COD_CARGA}>
                              {val.TIPO} - {val.NUMERO}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className={style.bigbags}>
                    <div className={style.peso_bigbag}>
                      <label>Pedido MIC</label>
                      <select
                        onChange={(e) => {
                          setTransportadora(""); // Resetando o valor da transportadora
                          handlePedidoChange(e); // Mantendo o comportamento da função handlePedidoChange
                        }}
                        value={pedidoMic} // Define o valor atual selecionado
                      >
                        <option disabled value="">
                          Escolha uma opção
                        </option>
                        {pedidosByDoc?.map((val) => (
                          <option
                            key={val.NR_PEDIDO}
                            value={val.NR_PEDIDO}
                            style={{
                              backgroundColor:
                                val.BLOQUEAR_PEDIDO === "S"
                                  ? "#f8d7da"
                                  : "transparent", // Vermelho claro para pedidos bloqueados
                              color:
                                val.BLOQUEAR_PEDIDO === "S" ? "red" : "black", // Cor do texto para pedidos bloqueados
                            }}
                            disabled={val.BLOQUEAR_PEDIDO === "S"} // Desabilitar a opção se o pedido estiver bloqueado
                          >
                            {val.NR_PEDIDO}{" "}
                            {val.BLOQUEAR_PEDIDO === "S" && "- BLOQUEADO"}{" "}
                            {/* Adiciona "BLOQUEADO" ao texto */}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className={style.quantidade}>
                      <label>Destino</label>
                      <p>{destino || ""}</p>
                    </div>
                  </div>

                  <div
                    className={style.form_controlsaldo}
                    style={{
                      backgroundColor:
                        porcentagem !== null && porcentagem < 90
                          ? "green"
                          : "red",
                    }}
                  >
                    <div className={`${style.label} ${style.value}`}>
                      <b>SALDO</b>
                    </div>
                    <div className={style.value}>
                      {porcentagem !== null ? porcentagem.toFixed(2) : ""} %
                    </div>
                    <div className={style.value}>
                      {saldoCadastro !== null ? saldoTons.toFixed(2) : ""} Tons
                    </div>
                  </div>
                </fieldset>
                <div className={style.form_control}>
                  <fieldset className={style.fieldset_alt}>
                    <legend className={style.legend}>Transportadora</legend>
                    <select
                      onChange={(e) => {
                        setTransportadora(e.target.value);
                      }}
                    >
                      <option disabled selected>
                        Escolha opção
                      </option>
                      {transportadoras?.map((val) => {
                        return (
                          <option
                            key={val.ID_TRANSPORTADORA_PEDIDO}
                            value={val.COD_TRANSP}
                          >
                            {val.NOME_REDUZIDO}
                          </option>
                        );
                      })}
                    </select>
                  </fieldset>
                </div>

                <div className={style.button}>
                  <SubmitButton
                    text={"Cadastrar"}
                    onClick={validaDados}
                    onkeypress={(e) => validaTecla(e)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Modal para autenticação de dois fatores */}
          {
            // showModal && ( <div className={style.modalBackdrop}>
            //   <div className={style.modal}>
            //     <h2>Autenticação de Dois Fatores</h2>
            //     <p>Insira o código de autenticação:</p>
            //     <input
            //       type="text"
            //       value={authCode}
            //       onChange={(e) => setAuthCode(e.target.value)}
            //       placeholder="Código 2FA"
            //     />
            //     <div className={style.modalButtons}>
            //       <button className={style.validateButton} onClick={handleAuthSubmit} disabled={isAuthenticating}>Validar</button>
            //       <button className={style.cancelButton} onClick={handleCloseModal}>Cancelar</button>
            //     </div>
            //   </div>
            // </div>)
          }
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <PesagemInicial />
    </SnackbarProvider>
  );
}
